import { useEffect, useRef, useState } from 'react';

import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { Swipe as S } from 'react-sdk/activities/Swipe';
import ScaleManager from 'react-sdk/ScaleManager';
import SoundPlayer from 'react-sdk/SoundPlayer';
import { mapValues } from 'react-sdk/utils';
import classes from './Swipe.module.css';
import SwipeRecap from './SwipeRecap/SwipeRecap';

const SwipeProposition = ({proposition, onFinished}) => {

  let startX = useRef(null)

  const [tx, setTX] = useState(0);
  const [angle, setAngle] = useState(0);
  const [active, setActive] = useState(false);

  const answered = !!proposition.userAnswer


  useEffect(() => {

    // setTransforms([0, 0])
    setAngle(0)

  }, [proposition]);

  useEffect(() => {
    if(answered) {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [answered]);

  let style = {
    // "--tx": tx + "px",
    // "--angle": angle + "deg",
    "--transformOrigin": "1200px",

    // transform: `rotateZ(${angle}deg)`,
    transform: `translateX(${tx}px)`,

    // opacity: answered ? 0 : 1
  }


  useEffect(() => {
    if(active) {
      window.addEventListener("mousemove", handleMouseMove)
      window.addEventListener("mouseup", handleMouseUp)

      window.addEventListener("touchmove", handleTouchMove)
      window.addEventListener("touchend", handleMouseUp)
    }
    return  () => {
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("touchmove", handleTouchMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [active, tx]);

  function calulateAngle(x) {
    let angle = mapValues(x, 0, window.innerWidth, -90, 90, true)
    return angle
  }


  function handleMouseDown(e) {
    SoundPlayer.playSound("click")
    if(answered) return
    if(e?.touches?.[0]?.clientX) {

      startX.current = e?.touches[0]?.clientX / ScaleManager.scale
    }
    else {
      startX.current = e.clientX / ScaleManager.scale

    }
    setActive(true)
  }
  function handleMouseMove(e) {
    if(!active) return
    if(answered) return
    setTX(e.clientX / ScaleManager.scale - startX.current)
    // setAngle(calulateAngle(e.clientX))
  }
  function handleTouchMove(e) {
    if(!active) return
    if(answered) return
    let x = e?.touches[0]?.clientX  / ScaleManager.scale

    // if(x) setAngle(calulateAngle(x))
    if(x) setTX(x- startX.current)
    }

  function handleMouseUp(e) {
    if(!active) return

    console.log(tx);
    if(Math.abs(tx) > 250) {
      setTX(1300 * Math.sign(tx))
      setTimeout(() => {
        handleAnswer()
      }, 500)
    }
    else {
      setTX(0)
      SoundPlayer.playSound("click")
    }
    setActive(false)
  }

  function handleAnswer() {

    // let value = angle < 0 ? false : true
    let value = tx < 0 ? false : true
    proposition.answer(value)

    onFinished()
    // setTimeout(() => {
    // }, 3000)
  }

  let answerOpacity = mapValues(Math.abs(tx), 0, 250, 0, 0.99, true)

  return(

      <div
      key={proposition.ID}
      className={clsx(classes.card, active && classes.dragging)}
      style={style}
      onMouseEnter={e => SoundPlayer.playSound("rollover")}
      onMouseDown={handleMouseDown}
      onTouchStart={handleMouseDown}
      >
        <div className={classes.card_bg} />
        <div className={classes.card_text}>
          {proposition.Text }
          {proposition.media && <img src={proposition.media} />}
        </div>


        {!answered &&
        <div className={classes.answer} >
          {tx > -50 && tx < 50 &&

          <div className={classes.arrows_ctnr}>
               <svg
               className={classes.double_arrow}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.0008 145.8926 1622.0015 220.2149"

  >
    <path
      d="M 1487.941 169.941 L 1487.941 216 L 134.059 216 L 134.059 169.941 C 134.059 148.559 108.208 137.851 93.088 152.97 L 7.029 239.029 C -2.344 248.402 -2.344 263.597 7.029 272.97 L 93.088 359.029 C 108.207 374.148 134.059 363.44 134.059 342.058 L 134.059 296 L 1487.941 296 L 1487.941 342.059 C 1487.941 363.441 1513.792 374.149 1528.912 359.03 L 1614.971 272.971 C 1624.344 263.598 1624.344 248.403 1614.971 239.03 L 1528.912 152.971 C 1513.793 137.851 1487.941 148.559 1487.941 169.941 Z"
      transform="matrix(1, 0, 0, 1, 0, -1.1368683772161603e-13)"
    />
  </svg>


            <div className={classes.arrows}>

              <div className={clsx(classes.arrow)}>
                {/* <FaArrowLeft /> */}
                <div className={clsx(classes.arrow_text)}>{proposition.incorrectText}</div>
              </div>
              <div className={clsx(classes.arrow)}>
                {/* <FaArrowRight /> */}
                <div className={clsx(classes.arrow_text)}>{proposition.correctText}</div>
              </div>
            </div>
          </div>}

          {tx <= -50 &&
          <div key={proposition.ID + "_0"} className={classes.future_answer} style={{opacity: answerOpacity}}>
            {proposition.incorrectText}
          </div>}

          {tx >= 50 &&
          <div key={proposition.ID + "_1"} className={classes.future_answer} style={{opacity: answerOpacity}}>
            {proposition.correctText}
          </div>}

        </div>}
      </div>

  )
}


/**
* @param {object} props
* @param {S} props.instance
*/
const Swipe = ({instance, onReadyToValidate}) => {
  const [propositionIndex, setPropositionIndex] = useState(0);

  let proposition = instance.Propositions[propositionIndex]


  function onPopositionDone() {
    // setTimeout(() => {
      if(propositionIndex < instance.Propositions.length - 1) {
        setPropositionIndex(i => i+1)
      }
      else {
        // onReadyToValidate(true)
        instance.localCorrect()

      }

    // }, 200)
  }

  return (
    <div className={classes.Swipe}>
      {!instance.result &&
      <div className={classes.card_container}>
        <SwipeProposition key={proposition.ID} proposition={proposition} onFinished={onPopositionDone} />
      </div>}

      {instance.result &&
      <SwipeRecap instance={instance} />}

    </div>
  );
};

export default observer(Swipe);
